import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const BlockchainContext = createContext();

export const BlockchainProvider = ({ children }) => {
  const [blockchains, setBlockchains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/api/blockchains')
      .then(res => {
        // Separate supported and unsupported blockchains
        const supportedBlockchains = (res.data.blockchains || [])
          .filter(blockchain => blockchain.is_supported)
          .sort((a, b) => a.name.localeCompare(b.name));
        
        const unsupportedBlockchains = (res.data.blockchains || [])
          .filter(blockchain => !blockchain.is_supported)
          .sort((a, b) => a.name.localeCompare(b.name));
        
        // Combine: supported first, then unsupported
        const allBlockchains = [...supportedBlockchains, ...unsupportedBlockchains];
        setBlockchains(allBlockchains);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <BlockchainContext.Provider value={{ blockchains, loading, error }}>
      {children}
    </BlockchainContext.Provider>
  );
};

export const useBlockchains = () => useContext(BlockchainContext); 